import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48090fb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TableBox" }
const _hoisted_2 = { class: "TableTop" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("未开始")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("进行中")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已延期")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("已挂起")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("已关闭")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_11 = { class: "TableTopBtn" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("帮助中心")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = { class: "tableBottom" }
const _hoisted_18 = { class: "sortingBox" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("排序")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_VEselect = _resolveComponent("VEselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AddOrEditDialog = _resolveComponent("AddOrEditDialog")!
  const _component_PageMain = _resolveComponent("PageMain")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageMain, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: _ctx.query,
            inline: "",
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
            ref: "queryFormRef"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "项目名称：",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.query.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
                    placeholder: "请输入项目名称",
                    size: "small",
                    clearable: "",
                    onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList('place')))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目代码：",
                prop: "code"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.query.code,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.code) = $event)),
                    placeholder: "请输入项目代码",
                    size: "small",
                    clearable: "",
                    onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList('place')))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目类型：",
                prop: "type_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VEselect, {
                    selectValue: _ctx.query.type_id,
                    "onUpdate:selectValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.type_id) = $event)),
                    apiUrl: ['typeManagement', 'getList'],
                    placeholder: "请选择项目类型",
                    queryName: "name",
                    objLabel: "name",
                    objKey: "id",
                    onClear: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getList('place'))),
                    size: "small"
                  }, null, 8, ["selectValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目负责人：",
                prop: "user_type1_name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.query.user_type1_name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.user_type1_name) = $event)),
                    placeholder: "请输入项目负责人",
                    size: "small",
                    clearable: "",
                    onClear: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList('place')))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "项目时间段：",
                prop: "date_interval"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.query.date_interval,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.query.date_interval) = $event)),
                    "range-separator": "至",
                    type: "daterange",
                    size: "small",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    clearable: "",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getList('place')))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "状态：",
                prop: "status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.query.status,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.query.status) = $event)),
                    size: "small",
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getList('place'))),
                    style: {"display":"block"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 3 }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 4 }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: 5 }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getList('place')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.init()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.$globalFun.ifAuth(_ctx.$route, '新增'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  icon: "plus",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "tableListRef",
          class: "TableList",
          border: "",
          data: _ctx.list,
          height: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "项目名称",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "type_name",
              label: "项目类型",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "code",
              label: "项目代号",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "项目负责人",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.user_type1.username), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "start_date",
              label: "项目开始时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "end_date",
              label: "项目结束时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "sort",
              label: "排序",
              align: "center",
              sortable: "",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                (_ctx.ifSorting)
                  ? (_openBlock(), _createBlock(_component_el_input_number, {
                      key: 0,
                      modelValue: scope.row.newSorting,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.newSorting) = $event),
                      min: 0,
                      size: "mini",
                      style: {"width":"100px"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(scope.row.sort), 1)
                    ], 64))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status_str",
              label: "状态",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: _ctx.statusColor[scope.row.status] })
                }, _toDisplayString(scope.row.status_str), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "is_show",
              label: "前台状态",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_switch, {
                  disabled: !_ctx.$globalFun.ifAuth(_ctx.$route, '显示/隐藏'),
                  modelValue: scope.row.is_show,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.is_show) = $event),
                  "active-value": 1,
                  "inactive-value": 2,
                  onChange: ($event: any) => (_ctx.editStatus(scope.row)),
                  "active-color": "#13ce66",
                  "inactive-color": "#ff4949"
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "320",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "warning",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.onHelp(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (_ctx.$globalFun.ifAuth(_ctx.$route, '详情'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "mini",
                      onClick: ($event: any) => (_ctx.onShowDetails(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$globalFun.ifAuth(_ctx.$route, '编辑'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.onAddOrEdit(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$globalFun.ifAuth(_ctx.$route, '删除'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "danger",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.onDel(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_ctx.list.length > 0 && _ctx.$globalFun.ifAuth(_ctx.$route, '排序'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.ifSorting)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        onClick: _ctx.onSortingShow
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: _ctx.onSortingSave
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.ifSorting = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        })
                      ], 64))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.ifSorting)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                background: "",
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange,
                "current-page": _ctx.query.page,
                "page-sizes": [20, 40, 60, 100],
                "page-size": _ctx.query.paginate,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.total
              }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_AddOrEditDialog, { ref: "addOrEditDialogRef" }, null, 512)
    ]),
    _: 1
  }))
}